var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtmlBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2{stroke:#212121;strokeMiterlimit:10;strokeWidth:1.25px;}.cls-2{fill:#fcfcfc;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "html") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exported_white"
  }, /*#__PURE__*/React.createElement("g", {
    id: "html"
  }, /*#__PURE__*/React.createElement("g", {
    id: "html-2",
    "data-name": "html"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "8.79 6.26 12.52 52.68 31.79 57.86 49.82 53.09 54.38 6.26 8.79 6.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "12.07 9.99 15.27 49.73 31.79 54.13 47.2 50.08 51.1 9.99 12.07 9.99"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "htmlFace",
    className: "cls-2",
    points: "45.88 15.59 17.29 15.59 18.53 32.99 38.42 32.99 38.01 40.45 31.38 42.11 25.16 40.45 25.16 35.9 18.95 35.9 19.36 45.01 31.38 48.74 43.4 45.01 44.64 27.19 23.92 27.19 23.5 21.39 45.47 21.39 45.88 15.59"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlBlack);
export default __webpack_public_path__ + "static/media/html_black.71b14be921660dd6d1d4a3b39d68e958.svg";
export { ForwardRef as ReactComponent };